import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import TaskHeader from "./TaskHeader";
import TaskTable from "./TaskTable";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import { useLocation } from "react-router-dom";
const TaskList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [permission, setPermission] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusData, setStatusData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [formInquiryData, setFormInquiryData] = useState({
    from_date: "",
    to_date: "",
    status: "",
  });

  const handleChange = (name, value) => {
    setFormInquiryData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchAllData = async () => {
    const form = new FormData();
    form.append("created_by", userId);
    form.append("moduleId", M_id);
    form.append("userId", userId);
    const statusData = await fetchFormData("task-status/all", form);
    if (statusData) {
      const states = statusData.data;
      setStatusData(getValueLabel(states, "task_status_name", "id") || []);
    }
  };
  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const M_id = queryParams.get("id");

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", M_id);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;

        setPermission(perm);
      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [M_id]);

  useEffect(() => {
    fetchAllData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    if (!formInquiryData.from_date && formInquiryData.to_date) {
      topTost({
        title: "Please select From Date before selecting To Date.",
        icon: "error",
      });
    } else if (formInquiryData.from_date && !formInquiryData.to_date) {
      topTost({
        title: "To Date is required when From Date is selected",
        icon: "error",
      });
    } else if (
      formInquiryData.from_date &&
      formInquiryData.to_date &&
      new Date(formInquiryData.from_date) > new Date(formInquiryData.to_date)
    ) {
      topTost({
        title: "From Date should be less than or equal to To Date",
        icon: "error",
      });
    } else {
      try {
        const form = new FormData();
        form.append("from_date", formInquiryData.from_date);
        form.append("to_date", formInquiryData.to_date);
        form.append("status", formInquiryData.status);
        form.append("moduleId", M_id);
        form.append("userId", userId);

        const response = await fetchFormData(
          "task/filterTasks",
          form,
          "POST",
          true
        );

        if (response && response.data) {
          setFilterData(response.data);
        } else {
          topTost({
            title: response?.message || "No tasks found",
            icon: "info",
          });
        }
      } catch (error) {
        console.error("Filter submit error:", error);
        topTost({
          title: "Unexpected error occurred",
          icon: "error",
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleReset = () => {
    setFormInquiryData({
      from_date: "",
      to_date: "",
      status: "",
    });
    setFilterData([]);
  };
  
  const handleClose = () => {
    setShowFilters(!showFilters);
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <TaskHeader
              onToggleFilter={() => setShowFilters(!showFilters)}
              permission={permission}
            />
          </PageHeader>

          {showFilters && (

              <div className="main-content-top">
                <div className="row">
                  <div className="col-lg-12 mt-3">
                    <div className="card stretch stretch-full function-table">
                      <div className="card-body p-10">
                        <form onSubmit={handleSubmit}>
                          <div className="row px-3 mt-3">
                            {/* From Date */}
                            <div className="col-lg-4">
                              <Input
                                label="From Date"
                                name="from_date"
                                type="date"
                                value={formInquiryData.from_date}
                                onChange={handleChange}
                                placeholder="From Date"
                                icon="feather-calendar"
                              />
                            </div>

                            {/* To Date */}
                            <div className="col-lg-4">
                              <Input
                                label="To Date"
                                name="to_date"
                                type="date"
                                value={formInquiryData.to_date}
                                onChange={handleChange}
                                placeholder="To Date"
                                icon="feather-calendar"
                              />
                            </div>

                            {/* Status */}
                            <div className="col-lg-4 ">
                              <div className="row align-items-center">
                                {/* Label */}
                                <div className="col-lg-4">
                                  <label className="fw-semibold">Status:</label>
                                </div>

                                {/* Dropdown */}
                                <div className="col-lg-8">
                                  <SelectDropdown
                                    options={statusData}
                                    value={Number(formInquiryData.status)}
                                    selectedOption={
                                      statusData.find(
                                        (opt) =>
                                          opt.value ===
                                          Number(formInquiryData.status)
                                      ) || null
                                    }
                                    defaultSelect="Select Status"
                                    onSelectOption={(option) =>
                                      setFormInquiryData((prev) => ({
                                        ...prev,
                                        status: option.value,
                                      }))
                                    }
                                    icon="feather-user"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Buttons */}
                            <div className="col-lg-12 mt-4 d-flex justify-content-center">
                              <div className="gap-xxl-2 d-flex">
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary"
                                  disabled={isSubmitting}
                                  onClick={handleClose}
                                >
                                  Close
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary me-2"
                                  disabled={isSubmitting}
                                  onClick={handleReset}
                                >
                                  Reset
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-lg btn-primary me-2"
                                  disabled={isSubmitting}
                                >
                                  {isSubmitting ? "Submitting..." : "Search"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
         
          )}

          <div className="main-content">
            <div className="row">
              <TaskTable filteredData={filterData} permission={permission} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default TaskList;
